import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';

interface StepItemLinkContainerProps {
    isActive?: boolean;
    isSubStep?: boolean;
    isParentSectionActive?: boolean;
    isLastNode?: boolean;
    hasIcon?: boolean;
    isHovered?: boolean;
    children: React.ReactNode;
}

export const StepItemLinkContainer = ({
    isActive = false,
    isSubStep = false,
    isParentSectionActive = false,
    isLastNode = false,
    hasIcon = false,
    isHovered = false,
    children,
}: StepItemLinkContainerProps) => {
    let backgroundColor = 'transparent';
    if (isSubStep) {
        if (isHovered) {
            backgroundColor = antGrey.grey9;
        } else if (isParentSectionActive) {
            backgroundColor = 'rgba(89, 89, 89, 0.25)';
        }
    } else {
        if (isActive) {
            backgroundColor = antGrey.grey8;
        } else if (isHovered) {
            backgroundColor = antGrey.grey9;
        }
    }

    return (
        <div
            style={{
                backgroundColor,
                display: 'flex',
                justifyContent: hasIcon ? 'space-between' : 'flex-end',
                alignItems: 'center',
                paddingLeft: 16,
                paddingRight: 16,
                borderTop: isSubStep ? 'none' : `1px solid ${runwayColors.navGrey}`,
                borderBottom:
                    isSubStep ? 'none'
                    : isLastNode ? `1px solid ${runwayColors.navGrey}`
                    : 'none',
            }}
        >
            {children}
        </div>
    );
};

export const StepItemTextContainer = ({
    children,
    isSubStep = false,
}: {
    children: React.ReactNode;
    isSubStep?: boolean;
}) => {
    return (
        <div
            style={{
                display: 'flex',
                minWidth: 0,
                overflow: 'hidden',
                ...(isSubStep ? {} : { marginLeft: 4, marginRight: 10 }),
            }}
        >
            {children}
        </div>
    );
};

export const StepItemText = ({
    children,
    shouldBoldText = false,
    nonBlocking = false,
    isSubStep = false,
}: {
    children: React.ReactNode;
    shouldBoldText?: boolean;
    nonBlocking?: boolean;
    isSubStep?: boolean;
}) => {
    return (
        <Text
            style={{
                fontSize: isSubStep ? 12 : 14,
                textAlign: 'right',
                fontWeight: shouldBoldText ? 600 : 400,
                color: nonBlocking ? antGrey.grey7 : antGrey.grey1,
            }}
            ellipsis
        >
            {children}
        </Text>
    );
};
